import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { CustomEase } from "gsap/CustomEase";
import { media } from "../utils/MediaQueries";
import { CountUp } from 'countup.js';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);
gsap.registerPlugin(CustomEase);



function contactBannerAnimation() {

  // Split text banner titles
  const pageTitle = new SplitText(".js-contact-banner-title", {type: "lines", tag: "span"});
  const bannerAddress = new SplitText(".js-contact-banner-address", {type: "lines", tag: "span"});
  const bannerPhone = new SplitText(".js-contact-banner-phone", {type: "lines", tag: "span"});

  // Set up variables
  const logo = $('.top-nav__logo'); 
  const navButton = $('.js-nav-button-wrapper')

  const contactBannerTitle = $('.js-contact-banner-title span');
  const contactBannerAddress = $('.js-contact-banner-address span');
  const contactBannerPhone = $('.js-contact-banner-phone span');
  const contactBannerButton = $('.js-contact-banner-button');
  const contactBannerLine = $('.js-contact-banner-line');
  const contactBannerMap = $('.js-contact-banner-map');

  const contactFormSection = $('.contact-two');
  const contactFormLine = $('.js-contact-form-line');
  const contactFormWrapper = $('.js-contact-form-wrapper');

  
  if (media.lg) {
    // Smaller screens

    const loadBannerMobileTL = gsap.timeline();
    //loadBannerMobileTL.add( function() { navButton.addClass('light'); } );
    loadBannerMobileTL.from( contactBannerMap, { clipPath: "inset(0% 0% 100% 0%)", duration: 1.2, ease: "power2.inOut" } );
    loadBannerMobileTL.from( contactBannerTitle, { clipPath: "inset(0% 0% 100% 0%)", duration: 1.2, ease: "power2.inOut" }, ">-=1.1" );
    loadBannerMobileTL.from( contactBannerLine, { clipPath: "inset(0% 100% 0% 0%)", duration: 1.2, ease: "power2.inOut" }, ">-=1.1");
    loadBannerMobileTL.from( contactBannerAddress, { clipPath: "inset(0% 0% 100% 0%)", duration: 1.2, ease: "power2.inOut" }, ">-=1.1");
    loadBannerMobileTL.from( contactBannerPhone, { clipPath: "inset(0% 0% 100% 0%)", duration: 1.2, ease: "power2.inOut" }, ">-=1.1" );
    loadBannerMobileTL.from( contactBannerButton, { clipPath: "inset(0% 0% 100% 0%)", duration: 0.8, ease: "power2.inOut" }, ">-=1.1" );
    loadBannerMobileTL.from( logo, { opacity: 0, duration: 1.2, ease: "power2.inOut" }, ">-=1.5" );
    loadBannerMobileTL.from( navButton, { opacity: 0, duration: 1.2, ease: "power2.inOut" }, ">-=1.5" );
    
    const contactTL = gsap.timeline({ paused: false, });  
    contactTL.fromTo( '.js-contact-form-wrapper', { opacity: 0, y: 70, }, { opacity: 1, y: 0, ease: "none", }, );
    ScrollTrigger.create({
      trigger: ".js-contact-form-wrapper",
      start: 'top bottom-=20px',
      fastScrollEnd: true,
      once: true,
      end: "bottom 80%", 
      toggleClass: 'twk-aos-animating',
      onEnter: () => section.classList.add('twk-aos-animate'),
      onLeave: () => section.classList.add('twk-aos-animated'),
      animation: contactTL
    })
    

  } else {
    // Large screens

    // Don't allow user to scroll until banner animation is done
    if ( $('body').hasClass('page-template-tpl-contact') ) {
      $('body').addClass('no-scroll');
    }
    

    // Banner Loading animation
    const loadBannerTL = gsap.timeline();
    loadBannerTL.add( function() { navButton.addClass('light'); } );
    loadBannerTL.from( contactBannerTitle, { clipPath: "inset(0% 0% 100% 0%)", duration: 1.2, ease: "power2.inOut" } );
    loadBannerTL.from( contactBannerLine, { clipPath: "inset(0% 100% 0% 0%)", duration: 1.2, ease: "power2.inOut" }, ">-=1.1");
    loadBannerTL.from( contactBannerMap, { clipPath: "inset(0% 0% 0% 100%)", duration: 1.2, ease: "power2.inOut" }, ">-=1.1");
    loadBannerTL.from( contactBannerAddress, { clipPath: "inset(0% 0% 100% 0%)", duration: 1.2, ease: "power2.inOut" }, ">-=1.1");
    loadBannerTL.from( contactBannerPhone, { clipPath: "inset(0% 0% 100% 0%)", duration: 1.2, ease: "power2.inOut" }, ">-=1.1" );
    loadBannerTL.from( contactBannerButton, { clipPath: "inset(0% 0% 100% 0%)", duration: 0.8, ease: "power2.inOut" }, ">-=1.1" );
    loadBannerTL.from( logo, { opacity: 0, duration: 1.2, ease: "power2.inOut" }, ">-=1.5" );
    loadBannerTL.from( navButton, { opacity: 0, duration: 1.2, ease: "power2.inOut" }, ">-=1.5" );
    loadBannerTL.add(function () { $("body").removeClass("no-scroll"); }, ">");
    
    // Banner scroll animation
    // Timeout function so that scrolltrigger animation doesn't interfere with loading animation
    setTimeout(()=> {
      const bannerScrollTL = gsap.timeline({
        ease: 'none',
        scrollTrigger: {
          trigger: ".scroll-section-contact",
          pin: true,
          pinSpacing: true,
          scrub: 0.1,
          start: "top top",
          end: "185% top",
          toggleActions: "play pause play reset",
          onEnter: () => {
            document.querySelector( '.js-nav-button-wrapper' ).classList.add( 'light' )
            document.querySelector( '#page-wrap' ).classList.add( 'fixed-gold-bar' )
            document.querySelector( '.top-nav__logo' ).classList.add( 'fixed-logo' )
          },
          onEnterBack: () => {
            document.querySelector( '.js-nav-button-wrapper' ).classList.add( 'light' )
            document.querySelector( '#page-wrap' ).classList.add( 'fixed-gold-bar' )
            document.querySelector( '.top-nav__logo' ).classList.add( 'fixed-logo' )
          },
          onLeave: () => {
            document.querySelector( '.js-nav-button-wrapper' ).classList.remove( 'light' )
            document.querySelector( '#page-wrap' ).classList.remove( 'fixed-gold-bar' )
            document.querySelector( '.top-nav__logo' ).classList.remove( 'fixed-logo' )
          },
          onLeaveBack: () => {
            document.querySelector( '.js-nav-button-wrapper' ).classList.remove( 'light' )
            document.querySelector( '#page-wrap' ).classList.remove( 'fixed-gold-bar' )
            document.querySelector( '.top-nav__logo' ).classList.remove( 'fixed-logo' )
          },
        }
      });
    

      bannerScrollTL.fromTo( contactBannerTitle, { clipPath: "inset(0% 0% -5% 0%)" }, { clipPath: "inset(0% 0% 100% 0%)",  } );
      bannerScrollTL.fromTo( contactBannerLine, { clipPath: "inset(0% -5% 0% 0%)" }, { clipPath: "inset(0% 100% 0% 0%)",  }, "<" );
      bannerScrollTL.fromTo( contactBannerAddress, { clipPath: "inset(0% 0% -5% 0%)" }, { clipPath: "inset(0% 0% 100% 0%)",  }, "<" );
      bannerScrollTL.fromTo( contactBannerPhone, { clipPath: "inset(0% 0% -5% 0%)" }, { clipPath: "inset(0% 0% 100% 0%)",  }, "<" );
      bannerScrollTL.fromTo( contactBannerButton, { clipPath: "inset(0% 0% -5% 0%)" }, { clipPath: "inset(0% 0% 100% 0%)",  }, "<" );
      bannerScrollTL.fromTo( contactBannerMap, { clipPath: "inset(0% 0% 0% -5%)" }, { clipPath: "inset(0% 0% 0% 100%)",  }, "<" );
      bannerScrollTL.set( contactFormSection, { xPercent: -100, opacity: 1}, '>'  );
      bannerScrollTL.fromTo( contactFormLine, { clipPath: "inset(0% 100% 0% 0%)" }, { clipPath: "inset(0% -5% 0% 0%)" }, "<" );
      bannerScrollTL.fromTo( contactFormWrapper, { opacity: 0, y: '50px' }, { opacity: 1, y: '0px' }, "<" );

      ScrollTrigger.sort();
    }
    , 1500);
  }

  
  
        
}





function contactAnimation() {
  contactBannerAnimation();
}

export default contactAnimation;
